// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2_I0r","imageUploader":"EGiftCard_imageUploader__3dRFo"};